/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LocationInputs */

const en_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const es_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const fr_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement`)
};

const de_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const ja_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場所`)
};

const zh_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const ar_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموقع`)
};

const id_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokasi`)
};

const it_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const ru_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Местоположение`)
};

const pt_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização`)
};

const ko_location = /** @type {(inputs: LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위치`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {LocationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const location = /** @type {((inputs?: LocationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LocationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_location(inputs)
	if (locale === "es") return es_location(inputs)
	if (locale === "fr") return fr_location(inputs)
	if (locale === "de") return de_location(inputs)
	if (locale === "ja") return ja_location(inputs)
	if (locale === "zh") return zh_location(inputs)
	if (locale === "ar") return ar_location(inputs)
	if (locale === "id") return id_location(inputs)
	if (locale === "it") return it_location(inputs)
	if (locale === "ru") return ru_location(inputs)
	if (locale === "pt") return pt_location(inputs)
	return ko_location(inputs)
});